import React from 'react';
import { GoogleAnalyticsScript } from './GoogleAnalyticsScript';
import { GoogleAdsScript } from './GoogleAdsScript';
import { StoreMarketingTagScripts } from './StoreMarketingTagScripts';
import { DSAnalyticsScript } from './DSAnalyticsScript';

export default function GoogleTags({ store, featureLocksStatus }) {
  const { googleTagFeatureStatus, googleAnalyticsFeatureStatus, fbPixelFeatureStatus } =
    featureLocksStatus;

  return (
    <>
      {/* Facebook pixel code */}
      {store?.store_marketing_tags?.facebook_pixel && !fbPixelFeatureStatus?.isLocked && (
        <>
          <script
            dangerouslySetInnerHTML={{
              __html: `
                      !function(f,b,e,v,n,t,s)
                      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                      n.queue=[];t=b.createElement(e);t.async=!0;
                      t.src=v;s=b.getElementsByTagName(e)[0];
                      s.parentNode.insertBefore(t,s)}(window, document,'script',
                      'https://connect.facebook.net/en_US/fbevents.js');
                      fbq('init', '${store?.store_marketing_tags.facebook_pixel}');
                      fbq('track', 'PageView');
                    `,
            }}
          />
          <noscript>
            <img
              height="1"
              width="1"
              style={{ display: 'none' }}
              src={`https://www.facebook.com/tr?id=${store?.store_marketing_tags.facebook_pixel}&ev=PageView&noscript=1`}
            />
          </noscript>
        </>
      )}
      {/** Google Tag manager (Specific to the user), non-blocking by nature, only rendered when JavaScript is disabled */}
      {store?.store_marketing_tags?.g_tag && (
        <noscript>
          <iframe
            src={`//www.googletagmanager.com/ns.html?id=${store?.store_marketing_tags?.g_tag}`}
            height="0"
            width="0"
            title="Google Tag Manager"
            style={{
              display: 'none',
              visibility: 'hidden',
            }}
          ></iframe>
        </noscript>
      )}
      {/* Google tag manager */}
      {store?.store_marketing_tags?.google_analytics &&
        !googleAnalyticsFeatureStatus?.isLocked && (
          <GoogleAnalyticsScript
            analyticsId={store?.store_marketing_tags?.google_analytics}
          />
        )}
      {/* Google ads */}
      {store?.store_marketing_tags?.google_ads && (
        <GoogleAdsScript adTagId={store?.store_marketing_tags?.google_ads} />
      )}
      {/** Google Tag manager (Specific to the user) */}
      {store?.store_marketing_tags?.g_tag && !googleTagFeatureStatus?.isLocked ? (
        <StoreMarketingTagScripts gtagId={store?.store_marketing_tags?.g_tag} />
      ) : (
        <DSAnalyticsScript />
      )}
    </>
  );
}
